import React, { useState, useEffect, useRef } from "react";
import classes from "./Departments.module.css";

//libraries and redux
import { useDispatch } from "react-redux";
import { ScrollActions } from "../../store/Slices/ScrollSlice";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

//components
import Menu from "./Menu/Menu";
import Space from "../UI/Space/Space";

//This component displays the Departments menu
/*
props.small: indicates if the departments component should be displayed in smaller form (without icons)
this happens in the pages other than the main one
*/
const Departments = (props) => {
  const dispatch = useDispatch();
  let container = useRef(null);

  gsap.registerPlugin(ScrollTrigger);

  //This useEffect keeps track of the scrolling position of the Component for ScrollProgress
  useEffect(() => {
    let trigger = ScrollTrigger.create({
      trigger: container.current,
      start: "top bottom",
      end: "bottom bottom",
      scrub: true,
      onUpdate: (self) => {
        // console.log("progress", self.progress);
        dispatch(ScrollActions.UpdateDepartments(self.progress));
      },
    });

    return () => {
      trigger.kill();
    };
  }, []);

  useEffect(() => {
    if (props.transparent) {
      const cont = document.getElementsByClassName(classes.container)[0];
      console.log("HERE")
      container.current.style.backgroundColor = "#ffffff48";
    }
  }, [props.transparent]);

  return (
    <div className={classes.container} ref={container}>
      {/* The Menu that contains the Departments' buttons */}
      <Menu small={props.small} />
      {props.small != true && <Space height={50} />}
    </div>
  );
};
export default Departments;
